<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="this.$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <!-- <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(total.gross, 'currency')
                    }}</span><small>Total
                    bruto</small></v-card>
            <v-card outlined class="px-2 py-1 mx-2"><span class="--total">{{
                $n(total.net, 'currency') }}</span><small>Total líquido</small></v-card>
            <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(documents.length) }}</span><small>{{
                $t('users.total') }}</small></v-card> -->
            <vue-json-to-csv :json-data="[]" :csv-title="`Templates (${computedDateFormatted})`"
                :separator="';'" :labels="csvLabels">
                <v-btn outlined color="primary" height="40" class="ml-2">
                    {{ $t("common.export") }}

                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </vue-json-to-csv>
        </div>
        <v-card outlined>
             <v-data-table :headers="headers" :items="documents" :items-per-page="5" :loading="loading">
            <template v-slot:[`item.createdOn`]="{ item }">
              {{ item.createdOn | dateTimeTz(item.timezone) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span class="green--text" v-if="item.status == 'success'">
                <v-icon size="20" class="mr-2" color="green">mdi-shield-check</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="red--text" v-if="item.status == 'blocked'">
                <v-icon size="20" class="mr-2" color="red">mdi-lock-clock</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
              <span class="orange--text" v-if="item.status == 'password_error'">
                <v-icon size="20" class="mr-2" color="orange">mdi-alert-circle-outline</v-icon> {{
                  $t(`accountSettings.security.status.${item.status}`) }}
              </span>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              {{ item.id }}
              <v-btn icon @click="openEdit(item)"><v-icon>mdi-pencil</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card>
        <v-dialog v-model="show" max-width="100%">
            <v-card width="100%" :loading="loading">
               <BuilderTemplate v-if="item" :item="item" :sizes="sizes"></BuilderTemplate>
            </v-card>
        </v-dialog>
       
       
    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import VueJsonToCsv from "vue-json-to-csv";
import { mapActions, mapState } from "vuex";

import { initializeApp } from "firebase/app";
import axios from "axios"
import BuilderTemplate from './BuilderTemplate.vue';
export default {
    name: 'OpecOrders',
    components: {
        VueJsonToCsv,
        BuilderTemplate
    },
    data() {
        return {
            show: false,
            isEditing: false,
            edit: false,
            tab: 0,
           
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],
            item: null,
            docToExport: []
        }
    },

    computed: {
        ...mapState("groupStores", [
            "allStores",
            "masterStore",
            "subStores",
            "selectedStore",
        ]),
        sizes(){
            const result = {
                width: null,
                height: null,
                fps: null
            }
            if(this.item){
                const {sizes, duration } = this.item
                result.width = sizes.split('x')[0]
                result.height = sizes.split('x')[1]
                result.duration = duration
                result.fps = 30
            }
            return result
        },
        total() {
            const res = {
                gross: 0,
                net: 0,
                agency: 0
            }
            // this.documents.forEach((item) => {
            //     if (item.info && item.info.price) {
            //         res.gross += item.info.price.gross
            //         res.net += item.info.price.net
            //         res.agency += item.info.price.agency
            //     }
            // })
            return res
        },
        csvLabels() {
            return {
                // name: { title: 'Nombre' },
                // company: { title: 'Empresa' },
                // document: { title: 'RUC' },
                // score: { title: 'Score' },
                // email: { title: "Correo Electrónico" },
                // phone: { title: "Teléfono" },
                // createdOn: { title: "Creado en" },
                // confirmedOn: { title: "Verificado en" }

            }
        },
        computedDateFormatted() {
            return moment().format("YYYY-MM-DD HH mm");
        },
        headers() {
            return [
               
                {
                    text: "Título",
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {
                    text: "Categoria",
                    align: 'start',
                    sortable: true,
                    value: 'category',
                },
                {
                    text: "Tipo de template",
                    align: 'start',
                    sortable: true,
                    value: 'type',
                },

                {
                    text: "Dimensões",
                    align: 'start',
                    sortable: true,
                    value: 'sizes',
                },

               
                {
                    text: "Criado em",
                    align: 'start',
                    sortable: true,
                    value: 'createdOn',
                },
                {
                    text: "Status",
                    align: 'start',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: "",
                    align: 'start',
                    sortable: false,
                    value: 'id'
                }
            ]
        },
     
    },
    mounted() {
        this.loadDocuments()
    },
    watch: {
        '$route.params.tab'(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : ''
        },
        'search': {
            // handler(value) {
            //     if (value) {
            //         if (this.$route.query.q != value) {
            //             this.$router.replace(`/sales/opec?q=${value}`)
            //         }
            //     }
            //     else {
            //         this.$router.replace(`/sales/opec`)
            //     }
            // }
        }
    },
    methods: {
        ...mapActions("groupStores", [
            "getAllStores",
            "getMasterStore",
            "getSubStores",
            "getSelectedStore",
        ]),
        openEdit(item){
            this.item = item
            this.show = true
        },
        getDate(date){
            return moment(`${date.year}-${date.month}-${date.monthDay}`).format('DD/MM/YYYY')
        },
        loadDocuments() {
            this.loading = true
            this.$axios.get(`builder/templates/?storeId=${config.projectId}&projectId=${config.projectId}`).then((docs) => {
                console.log('docs', docs.data.data)
                this.documents = docs.data.data
                // this.documents = res
                this.loading = false
            })
        },
        // saveScore(item){
        //     console.log('item', item)
        //     item.score = item.newScore
        //     item.openScore = false
        //     const firebase = initializeApp(config);
        //     const db = getFirestore(firebase);

        //     const masterRef = doc(db, "accounts", item.id);
        //     console.log('item to save', item);
        //     updateDoc(masterRef, {
        //         "score": item.score
        //     });

        //     this.loadDocuments()
        // },
        advance() {
            this.form.show = false
            if (this.form.action == 'edit') {
                this.edit = true
                this.isEditing = true
                this.tab = 1
            }
        },
       
        openLink(e) {
            this.pi.loading = true
            this.pi.show = true
            const prefix = this.$sandbox ? 'http://canaldoanuncio.test/api/v1/' : 'https://app.canaldoanuncio.com/api/v1/'
            if (e) {
                e.ready = false
                axios.get(`${prefix}security/open/link?region=sa-east-1&url=${e.url}&src=${e.url}`).then((res) => {
                    this.pi = {
                        ...e,
                        secure: res.data.data,
                        show: true,
                        loading: false
                    }
                    // this.pi.secure = res.data.data
                    // this.download_file(res.data.data, `${e.info.number}.pdf`)
                })
            }
        },

        downloadFile(e) {
            e.downloading = true
            const prefix = this.$sandbox ? 'http://canaldoanuncio.test/api/v1/' : 'https://app.canaldoanuncio.com/api/v1/'
            if (e) {
                e.ready = false
                axios.get(`${prefix}security/open/link?region=sa-east-1&url=${e.url}&src=${e.url}`).then((res) => {
                    this.download_file(res.data.data, `PI ${e.info.number}.pdf`)
                    e.downloading = false
                    // this.pi.secure = res.data.data
                    // this.download_file(res.data.data, `${e.info.number}.pdf`)
                })
            }
        },


        download_file(fileURL, fileName) {
            // for non-IE
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                    // window event not working here
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }

            // for IE < 11
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.hide-text {
    font-size: 0;
    text-indent: -999em;
}

.--total {
    line-height: .75em;
    text-align: center;
    display: block;
    font-weight: bold;
    padding-top: 2px;

    &+small {
        line-height: .75em;
        font-size: 70%;
        padding: 5px 0 0 0;
        display: block;
        text-align: center;
    }
}
.--subtable{    
    background: #fafafa;
    box-shadow: none;
    table{
        td, th{
            background: #fafafa;
        }
}
}
</style>